import { Link, useLocation } from 'react-router-dom';
import { ButtonLink } from '@/components/ui/Button';
import styles from './StatusPages.module.css';
import { routes } from '@/lib/routePaths';

export default function ForbiddenPage() {
  const location = useLocation();
  const attemptedPath = (location.state as { attemptedPath?: string } | null)?.attemptedPath;
  return <div className={styles.page}>
    <section className={styles.content}>
      <span className={styles.code}>403 · Access denied</span>
      <h1>You do not have access to this area</h1>
      <p>Your account is signed in, but this page requires a different role.</p>
      {attemptedPath && <p className={styles.path}>Attempted path: {attemptedPath}</p>}
      <div className={styles.actions}>
        <ButtonLink to={routes.overview}>Return to Overview</ButtonLink>
        <Link to={routes.security}>Review account security</Link>
      </div>
    </section>
  </div>;
}
